import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

export default function useUpdatePackaging() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const updatePackaging = async (id, code, label, is_active) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.put(`/packaging/${id}`, {
        code,
        label,
        is_active,
      });
      setIsSuccess(true);
      toast.success(
        response.data?.message || 'Type de packaging mis à jour avec succès.'
      );
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, updatePackaging };
}
